import { render, staticRenderFns } from "./TakeoutInformation.vue?vue&type=template&id=860653c4"
import script from "./TakeoutInformation.vue?vue&type=script&lang=ts"
export * from "./TakeoutInformation.vue?vue&type=script&lang=ts"
import style0 from "./TakeoutInformation.vue?vue&type=style&index=0&id=860653c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports